import {getEnv} from "../env";
import {callApi, updateStatus} from "../05-utils/commonUtils";

const ACTIONS = {
  IMAGE_ADD_SUCCESS: "IMAGE_ADD_SUCCESS",
  IMAGE_ADD_FAILED: "IMAGE_ADD_FAILED",
  IMAGE_ADD_PROGRESS: "IMAGE_ADD_PROGRESS",
  IMAGE_LOAD_SUCCESS: "IMAGE_LOAD_SUCCESS",
  IMAGE_LOAD_FAILED: "IMAGE_LOAD_FAILED",
  IMAGE_LOAD_PROGRESS: "IMAGE_LOAD_PROGRESS",
  IMAGE_REMOVE_SUCCESS: "IMAGE_REMOVE_SUCCESS",
  IMAGE_REMOVE_FAILED: "IMAGE_REMOVE_FAILED",
  IMAGE_REMOVE_PROGRESS: "IMAGE_REMOVE_PROGRESS",
  IMAGE_EDIT_SUCCESS: "IMAGE_EDIT_SUCCESS",
  IMAGE_EDIT_FAILED: "IMAGE_EDIT_FAILED",
  IMAGE_EDIT_PROGRESS: "IMAGE_EDIT_PROGRESS",
};

const loadImages = () => {
  let config = {
    method: "get",
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.IMAGE_LOAD_PROGRESS));
    callApi(
      getEnv("API_SERVER") + "/image/get_all_images",
      config,
      null,
      (data) => {
        dispatch(
          updateStatus(ACTIONS.IMAGE_LOAD_SUCCESS, {images: data.images}),
        );
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.IMAGE_LOAD_FAILED, {error: err}));
      },
    );
  };
};

const uploadImage = (data) => {
  let config = {
    method: "post",
    body: data,
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.IMAGE_ADD_PROGRESS, data));
    callApi(
      getEnv("API_SERVER") + "/image/upload_image",
      config,
      null,
      (data) => {
        dispatch(updateStatus(ACTIONS.IMAGE_ADD_SUCCESS, {path: data.path}));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.IMAGE_ADD_FAILED, {error: err}));
      },
    );
  };
};

const removeImage = (data) => {
  let postData = {
    type: data.type,
    name: data.name,
  };

  let config = {
    method: "post",
    body: postData,
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.IMAGE_REMOVE_PROGRESS, postData));
    callApi(
      getEnv("API_SERVER") + "/image/delete_image",
      config,
      null,
      () => {
        dispatch(updateStatus(ACTIONS.IMAGE_REMOVE_SUCCESS));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.IMAGE_REMOVE_FAILED, {error: err}));
      },
    );
  };
};

const updateImage = (data) => {
  let config = {
    method: "post",
    body: data,
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.IMAGE_EDIT_PROGRESS, data));
    callApi(
      getEnv("API_SERVER") + "/image/update_image",
      config,
      null,
      (data) => {
        dispatch(updateStatus(ACTIONS.IMAGE_EDIT_SUCCESS, data));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.IMAGE_EDIT_FAILED, {error: err}));
      },
    );
  };
};

export {ACTIONS, uploadImage, updateImage, removeImage, loadImages};



// WEBPACK FOOTER //
// ./src/01-actions/adminImages.js